var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroku(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7e57c2",
    d: "M7,41L7,7c0-2.209,1.791-4,4-4h26c2.209,0,4,1.785,4,3.994c0,8.018,0,25.991,0,34.01C41,43.214,39.209,45,37,45H11C8.791,45,7,43.209,7,41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.292,39.221v-16.68c0,0,1.085-3.991-13.364,1.633c-0.026,0.071-0.026-15.424-0.026-15.424l4.721-0.029v9.928c0,0,13.218-5.206,13.218,3.948v16.623L28.292,39.221L28.292,39.221L28.292,39.221z M30.982,14.73h-5.007c1.802-2.204,3.434-5.98,3.434-5.98h5.178C34.586,8.751,33.7,11.211,30.982,14.73L30.982,14.73L30.982,14.73z M14.987,39.192v-9.498l4.75,4.75L14.987,39.192L14.987,39.192z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.ccf3f92a1012f419b42d6d35016348f0.svg";
export { ForwardRef as ReactComponent };